// Feb-2026 v1.0 App Store submission build flag.
// When REACT_APP_APPSTORE_V1=true, the initial Apple review binary hides
// auth, donations, canvas checkout, email subscription and admin routes.
// The code stays in the tree — flip the env var to false in v1.1
// to re-enable everything. See /app/memory/PRD.md → "v1.0 App Store".
export const APPSTORE_V1 = process.env.REACT_APP_APPSTORE_V1 === 'true';
export const SHOW_AUTH      = !APPSTORE_V1;
export const SHOW_DONATE    = !APPSTORE_V1;
export const SHOW_CANVAS    = !APPSTORE_V1;
export const SHOW_EMAIL_SUB = !APPSTORE_V1;
// Feb-2026 (user): community upload STAYS ON even in App Store mode so
// anyone can contribute a shiur into the "Uploaded by the Chevra"
// bucket. Previously this was linked to the same flag that hid auth /
// donate, which is why /upload was returning 404 and the tile was
// missing from the More page. Apple guideline 1.2 (user-generated
// content) is satisfied because every submission lands in the moderated
// "Uploaded by the Chevra" bucket for admin sort — no content is auto-
// published under a real speaker.
export const SHOW_UPLOAD    = true;
export const SHOW_ADMIN     = !APPSTORE_V1;
// June-2026 (user): CC Network + CC Family Tree and the Videos "General
// Library" removed with no trace. Flip to true to bring them back.
export const SHOW_CC_PAGES = false;
export const SHOW_VIDEO_GENERAL_LIBRARY = false;
